var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";
export function ButtonAction(_a) {
    var children = _a.children, onClick = _a.onClick, className = _a.className;
    return (_jsx(Button, __assign({ onClick: onClick, variant: "outline", className: cn("self-end w-full max-w-[352px] min-w-[240px] bg-secondary text-primary border-2 border-primary", className) }, { children: children })));
}
